export const tapBarList = [
    {
        name: 'home',
        label: '首页',
        visible: true,
        event: 'click'
    },
    {
        name: 'course',
        label: '文档',
        visible: true,
        event: 'click'
    },
    {
        name: 'api',
        label: 'API',
        visible: true,
        event: 'click'
    },
    {
        name: 'example',
        label: '示例',
        visible: true,
        event: 'click'
    },
    {
        name: 'case',
        label: '案例',
        visible: true,
        event: 'hover',
        hover: {
            content:[{
                name: 'smartHome',
                label: '智能家居',
                path: 'https://vr.3vjia.com/v/3vj.html?id=a534a541-0e22-4b75-9515-1965446300eb',
                visible: true
            },{
                name: 'virtualShop',
                label: '全息店铺',
                path: 'https://vr.3vjia.com/v/3vj.html?id=f8a3cbac-b89f-485b-aec2-344b26c4ae6e',
                visible: true
            },{
                name: 'outdoor',
                label: '露天室外',
                path: 'https://vr.3vjia.com/v/3vj.html?id=cd5fdfbd-9522-4773-b01e-3f972860cb1d',
                visible: true
            },{
                name: 'showroom',
                label: '展厅带看',
                path: 'https://pre-air.alibaba.com/app/wanhuatong/cdn-pc-3d-showRoom/icbu-showroom-pc.html?wx_navbar_transparent=true&_aplus_page_enable=true&model=ailab&network=pre&model_source=ailab&ali_id=17380523214&model_id=1116011&member_id=200654030&vaccount_id=200943039',
                visible: true
            }]
        }
    },
    // {
    //     name: 'demo',
    //     label: '示例',
    //     visible: true,
    // },
    // {
    //     name: 'onlineEdit',
    //     label: '在线编辑',
    //     visible: true,
    // },{
    //     name: 'download',
    //     label: '下载',
    //     visible: true,
    // }
] 